export default "/institutions/maree.svg";